module.exports = __webpack_public_path__ + "img/0001.cffde051.jpg";